<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">商品管理</div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="商品名称" class="form-item-order-id">
                    <el-input v-model="searchForm.goodsName" placeholder="请输入" size="small"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" class="form-item-status">
                    <el-cascader size="small" clearable v-model="searchForm.categoryId" :props="cascaderProps"
                        :options="cascaderData"></el-cascader>
                </el-form-item>
                <el-form-item class="form-item-reset">
                    <el-button type="default" size="small" @click="resetSearch">重置</el-button>
                </el-form-item>
                <el-form-item class="form-item-search">
                    <el-button type="primary" size="small" @click="searchOrders">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 订单状态标签 -->
        <div class="status-tabs">
            <el-radio-group v-model="activeStatus" size="small" class="status-radio-group" @change="handleStatusChange">
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">上架中</el-radio-button>
                <el-radio-button label="0">已下架</el-radio-button>
            </el-radio-group>
            <el-button type="primary" size="small" @click="handleAddClick">发布商品</el-button>
        </div>
        <!-- 订单表格 -->
        <el-table :data="dataList" :border="true" style="width: 100%" class="order-table">
            <el-table-column label="商品封面图" width="120" align="center">
                <template slot-scope="scope">
                    <img :src="scope.row.thumb" alt="商品图片" class="goods-image">
                </template>
            </el-table-column>
            <el-table-column label="商品标题" width="200" align="center" prop="name">
            </el-table-column>
            <el-table-column label="分类" width="120" align="center" prop="goodscategory_name">
            </el-table-column>
            <el-table-column label="价格" width="120" align="center" prop="shop_price">
            </el-table-column>
            <el-table-column label="销量" width="120" align="center" prop="sales_sum">
            </el-table-column>
            <el-table-column label="总库存" width="120" align="center" prop="stock">
            </el-table-column>
            <el-table-column label="状态" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.is_check == 0">审核中</el-tag>
                    <el-tag type="success" v-if="scope.row.is_sale == 1 && scope.row.is_check == 1">上架中</el-tag>
                    <el-tag type="danger" v-if="scope.row.is_sale == 0 && scope.row.is_check == 1">已下架</el-tag>
                </template>
            </el-table-column>
            <!-- 金额列 -->
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleClick(scope.row, '1')">查看详情</el-button>
                    <el-button type="text" size="small" @click="handleClick(scope.row, '1')">编辑</el-button>
                    <el-button type="text" size="small" @click="handleClick(scope.row, '2')">查看评价</el-button>
                    <el-button type="text" size="small" @click="handleUpdateStatus(scope.row, '1')"
                        v-if="scope.row.is_sale == 0">上架</el-button>
                    <el-button type="text" size="small" @click="handleUpdateStatus(scope.row, '0')"
                        v-if="scope.row.is_sale == 1">下架</el-button>
                    <el-button type="text" size="small" @click="handleClick(scope.row, '3')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currentPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductList',
    data() {
        return {
            cascaderData: [], // 商品分类树
            cascaderProps: {
                value: 'aid',
                label: 'name',
                children: 'children',
            },
            searchForm: {
                goodsName: '',
                categoryId: [],
            },
            activeStatus: '-1',
            dataList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    mounted() {
        this.getGoodsList();
        this.getCategoryTree();
    },
    methods: {
        // 获取商品分类树
        getCategoryTree() {
            this.$api.getHomeShopFenlei().then(res => {
                res.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        item.disabled = false;
                    } else {
                        item.disabled = true;
                    }
                })
                this.cascaderData = res;
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        // 点击操作按钮
        handleClick(item, type) {
            switch (type) {
                // 查看详情
                case '1':
                    this.$emit('goToComponent', 'AddProduct', {
                        goods_id: item.aid,
                        partner_id: this.userInfo.user_merchant_id
                    });
                    break;
                // 查看评价 
                case '2':
                    this.$router.push({
                        path: '/ViewEvaluate',
                        query: {
                            goods_id: item.aid,
                            partner_id: this.userInfo.user_merchant_id
                        }
                    });
                    break;
                // 删除商品 
                case '3':
                    this.$confirm('确定要删除商品吗？', '删除商品', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.handleDelete(item);
                    })
                    break;
            }
        },
        // 删除商品 
        handleDelete(item) {
            this.$api.deleteShopProduct({
                goods_id: item.aid,
                partner_id: this.userInfo.user_merchant_id
            }).then(res => {
                this.$message.success('删除成功');
                this.getGoodsList();
            }).catch(err => {
                this.$message.error(err);
            });
        },
        // 更新商品状态
        handleUpdateStatus(item, type) {
            this.$api.updateShopProductStatus({
                goods_id: item.aid,
                is_sale: type,
                partner_id: this.userInfo.user_merchant_id
            }).then(res => {
                this.$message.success('操作成功');
                this.getGoodsList();
            }).catch(err => {
                this.$message.error(err);
            });
        },
        // 添加商品
        handleAddClick() {
            this.$emit('goToComponent', 'AddProduct', {
                partner_id: this.userInfo.user_merchant_id,
            });
        },
        // 切换状态状态
        handleStatusChange() {
            this.currentPage = 1;
            this.getGoodsList();
        },
        // 获取商品列表
        getGoodsList() {
            this.$api.getShopProductList({
                type: this.activeStatus,
                partner_id: this.userInfo.user_merchant_id,
                page: this.currentPage,
                list_rows: this.pageSize,
                name: this.searchForm.goodsName,
                goodscategory_id: this.searchForm.categoryId[1] || '',
            }).then(res => {
                this.dataList = res.data;
                this.total = res.total;
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getGoodsList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getGoodsList();
        },

        resetSearch() {
            this.searchForm = {
                goodsName: '',
                categoryId: ['', ''],
            }
            this.currentPage = 1;
            this.getGoodsList();
        },
        searchOrders() {
            this.currentPage = 1;
            this.getGoodsList();
        },
    }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.my-orders-container {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 搜索区域 */
.search-section {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.search-form {
    margin: 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: end;
    gap: 10px;
}

/* 为每个表单项目设置固定宽度 */
.form-item-order-id {
    width: 200px;
    text-align: left;
}

.form-item-status {
    width: 200px;
    text-align: left;
}

.form-item-date {
    width: 300px;
    text-align: left;
}

/* 确保输入框和日期选择器占满表单项目宽度 */
.search-form .el-input,
.search-form .el-date-editor {
    width: 100%;
}

/* 订单状态标签 */
.status-tabs {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.status-radio-group {
    display: flex;
    align-items: center;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格自定义样式 */
.order-table {
    border-radius: 8px;
    overflow: hidden;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
}

.goods-details {
    flex: 1;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

/* 订单信息样式 */
.order-info {
    margin-bottom: 10px;
}

.order-time {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.order-meta {
    display: flex;
    gap: 20px;
    font-size: 14px;
    color: #666;
}

/* 金额样式 */
.amount-label {
    font-size: 12px;
    color: #999;
    margin-bottom: 3px;
}

.amount-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

/* 状态样式 */
.status-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.status-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
}

.status-countdown {
    font-size: 12px;
    color: #ff4d4f;
}

/* 交易操作按钮样式 */
.trade-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

/* 按钮样式 */
.primary-btn {
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.default-btn {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.text-btn {
    font-size: 12px;
    color: #286CED;
    padding: 4px 0;
}

.apply-after-sales {
    color: #286CED;
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .trade-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}
</style>